export default {
    evaluation: 'تقييم'
}